
  import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
  import {
    Action,
    Getter,
  } from 'vuex-class';
  import ImageSelector from '@/components/ImageSelector.vue';
  import DialogUpdateTrainingCeo from '@/modules/admin/trainings/_components/DialogUpdateTrainingCeo.vue';
  import DlgSendCeoMail from '@/modules/admin/trainings/_components/DlgSendCeoMail.vue';

  @Component({
    components: {DlgSendCeoMail, DialogUpdateTrainingCeo, ImageSelector},
  })
  export default class CeoTable extends Vue {
    @Prop({type: Object, default: null}) private training!: any;

    @Action('admin/trainings/remove') private deleteTraining!: any;
    @Action('admin/trainings/read') private readTrainings!: any;
    @Action('admin/trainings/readOne') private readTraining!: any;
    @Action('admin/trainings/sendMail') private sendMail!: any;

    @Getter('admin/ceos/all') private ceos!: any;

    private headers: any = [
      {
        text: 'Unternehmen',
        align: 'left',
        value: 'company',
      },
      {
        text: 'Ansprechpartner',
        align: 'left',
        value: 'surname',
      },
      {
        text: 'Email',
        align: 'left',
        value: 'email',
      },
      {
        text: 'Kapazität',
        align: 'right',
        sortable: false,
        value: '',
      },
      {
        text: 'Email Status',
        align: 'right',
        value: 'emailStatus',
      },
      {
        text: '',
        align: 'right',
        value: '',
      },
    ];
    private loading: boolean = false;
    private search: string = '';

    get mappedCeos() {
      const mapped: any = [];
      this.ceos.forEach((ceo) => {
        const newCeo = JSON.parse(JSON.stringify(ceo));
        if (this.training && this.training.ceos) {
          Object.assign(newCeo, this.training.ceos.filter((el) => el.ceoId === ceo.id)[0]);
          mapped.push(newCeo);
        }
      });
      return mapped;
    }

    private sendCeoMail(ceoId) {
      this.loading = true;
      if (confirm('Email wirklich versenden?')) {
        this.sendMail({trainingId: this.training.id, ceos: [ceoId]})
          .then(() => {
            this.loading = false;
            this.readTraining({id: this.training.id});
          });
      }
    }
  }
